var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiraxisPatient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 472,
    height: 47,
    viewBox: "0 0 472 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3288_128345)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.392 16.4883L117.188 45.8149H129.608L132.475 37.852H137.08L129.392 16.4883Z",
    fill: "#587E85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.712 45.8136H165.276L147.187 2.50195H137.117L152.712 45.8136Z",
    fill: "#587E85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 2.15234V45.7436H11.4687V23.3139L21.84 31.6136V17.8606L1.64786 2.15234H0Z",
    fill: "#587E85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2203 2.15039L28.1719 17.8414V31.585L38.4627 23.2487V45.742H49.931V2.15039H48.2203Z",
    fill: "#587E85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.274 44.1869V33.7948C239.417 35.3861 243.181 36.5609 246.758 36.8671C247.992 36.977 249.168 36.977 250.279 36.9162C253.915 36.6834 255.953 35.7411 255.953 33.966C255.953 31.726 253.173 30.6 247.749 28.6411C240.28 25.9359 235.469 22.9735 235.469 15.1763C235.469 7.37911 242.196 2.28711 252.311 2.28711C256.751 2.28711 261.198 3.11948 264.157 4.30679V14.2953C261.505 12.6918 257.307 11.6266 253.237 11.6266C249.167 11.6266 246.573 12.9855 246.573 15.1155C246.573 17.1226 249.167 18.4815 254.349 20.489C261.811 23.3285 266.936 26.3396 266.936 33.9043C266.936 41.7628 260.763 46.4999 249.723 46.4999C244.663 46.5003 239.603 45.5458 236.274 44.1869Z",
    fill: "#587E85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3647 2.86914H57.8359V45.7992H69.3647V2.86914Z",
    fill: "#587E85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.216 2.86914H216.688V45.7992H228.216V2.86914Z",
    fill: "#587E85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.613 39.0585L106.326 28.2852C107.09 28.158 107.854 28.0304 108.619 27.7755C113.714 26.247 117.791 22.3612 117.791 15.8644C117.791 7.64782 111.23 2.87109 101.612 2.87109H77.2812V45.8007H88.81V30.7049V29.6865V21.3423V17.9665V11.4697H100.084C104.033 11.4697 106.008 13.5714 106.008 16.1832C106.008 19.4314 103.905 21.3423 99.8927 21.3423H94.9613V29.8545L104.479 45.8007H110.838L113.613 39.0585Z",
    fill: "#587E85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.25 12.2035L179.877 2.87109H165.609L181.087 24.1449L169.365 40.3459L171.649 45.8007H179.431L186.051 36.6034L186.25 12.2035Z",
    fill: "#587E85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.012 24.1433L212.553 2.86914H198.477L192 12.1882L192.001 36.6435L198.349 45.7992H212.617L197.012 24.1433Z",
    fill: "#587E85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.715 45.8199L137.12 2.50781L135.137 2.53137L132.766 8.3678L146.873 45.8199H152.715Z",
    fill: "#B4C5C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.287 27.0131H284.126V45.8318H281.383V2.94531H293.287C303.125 2.94531 307.351 7.95133 307.351 15.0387C307.351 22.4963 302.763 27.0131 293.287 27.0131ZM293.287 24.5697C301.486 24.5697 304.592 20.8409 304.592 15.0387C304.592 8.9918 301.486 5.38903 293.287 5.38903H284.126V24.5697H293.287Z",
    fill: "#A662A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.761 12.2305C333.109 12.2305 337.997 16.3221 339.826 21.3281V12.6561H342.569V45.8301H339.826V37.0953C337.997 42.1641 333.045 46.3189 325.761 46.3189C316.491 46.3189 309.758 39.6572 309.758 29.2117C309.758 18.703 316.491 12.2305 325.761 12.2305ZM326.14 14.6114C318.131 14.6114 312.58 20.0508 312.58 29.2117C312.58 38.3725 318.131 43.8756 326.14 43.8756C333.897 43.8756 339.826 38.1911 339.826 29.2117C339.826 20.3504 333.897 14.6114 326.14 14.6114Z",
    fill: "#A662A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.905 15.0364H348.891V12.6555H353.905V4.2207H356.648V12.6559H366.487V15.0368H356.648V36.9687C356.648 41.9826 358.304 43.3858 362.766 43.3858H366.487V45.8299H362.34C356.648 45.8299 353.905 43.5126 353.905 36.9691V15.0364H353.905Z",
    fill: "#A662A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.227 2.8809C371.227 1.47765 372.267 0.5 373.545 0.5C374.821 0.5 375.862 1.47765 375.862 2.8809C375.862 4.34698 374.821 5.2618 373.545 5.2618C372.267 5.2618 371.227 4.34698 371.227 2.8809ZM372.141 12.6562H374.885V45.8302H372.141V12.6562Z",
    fill: "#A662A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.911 46.3185C388.624 46.3185 381.781 39.8382 381.781 29.2117C381.781 18.6397 388.498 12.2305 397.911 12.2305C407.876 12.2305 413.378 19.31 413.378 27.0122C413.378 28.4782 413.378 29.2121 413.252 30.3153H384.588C384.841 39.539 391.068 43.938 397.911 43.938C404.455 43.938 409.153 40.4534 410.257 34.9503H413.126C411.849 41.4935 406.409 46.3185 397.911 46.3185ZM384.587 28.0526H410.619C411.044 18.8211 404.58 14.5482 397.848 14.5482C391.068 14.5482 384.903 18.884 384.587 28.0526Z",
    fill: "#A662A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.215 26.5863C446.215 18.5213 441.753 14.3669 435.1 14.3669C428.194 14.3669 423.306 18.7027 423.306 27.9263V45.8302H420.562V12.6566H423.306V19.6807C425.261 14.5487 430.022 11.9785 435.525 11.9785C442.92 11.9785 448.911 16.4407 448.911 26.4053V45.8306H446.215V26.5863Z",
    fill: "#A662A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.483 15.0384H453.469V12.6575H458.483V4.22266H461.226V12.6579H471.065V15.0388H461.226V36.9706C461.226 41.9845 462.882 43.3878 467.344 43.3878H471.065V45.8319H466.918C461.226 45.8319 458.483 43.5146 458.483 36.971V15.0384H458.483Z",
    fill: "#A662A7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3288_128345"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 471.068,
    height: 46,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiraxisPatient);
export default __webpack_public_path__ + "static/media/miraxis-patient.2a32b40c1ba2255b65857640edd86076.svg";
export { ForwardRef as ReactComponent };